module.exports = __webpack_public_path__ + "static/media/blyg.9d7512a7.mp3";